import Controller from "./captainAppVersions.controller";
import template from "./captainAppVersions.html";

const captainAppVersions = {
  template,
  controller: Controller,
};

export default captainAppVersions;



// WEBPACK FOOTER //
// ./src/pages/captainAppVersions/captainAppVersions.component.js